import React from 'react';
import logoSvg from '../../assets/logo.svg';
import logoStrokesSvg from '../../assets/logo-strokes.png';

// Main Syncratik logo - uses the gradient-filled SVG from assets
export const SyncratikLogo = ({ className = "h-8 w-8" }) => {
  return (
    <img
      src={logoSvg}
      alt="Syncratik Logo"
      className={className}
    />
  );
};

// Hero background strokes - using the logo-strokes SVG from assets
export const HeroBackgroundStrokes = ({ className }) => {
  return (
    <img
      src={logoStrokesSvg}
      alt=""
      className={className}
      style={{ objectFit: 'cover' }}
    />
  );
};

export default SyncratikLogo;
